import ProgressStepper from '@src/components/progress/ProgressStepper';
import './stepComplete.scss';

interface Props {
	title: string;
	text: string;	
  hasProgress?: boolean;
  subText?: string;
}
const StepComplete = ({title, text, hasProgress = false, subText}: Props) => {
	return (
		<div className={`step-complete-wrap ${hasProgress ? 'has-progress' : ''}`}>
      {hasProgress &&
        <div className='check-wrap'>
          <i className='icon icon-22 icon-check-white' />
        </div>
      }
			<div className="complete-title">{title}</div>
			<p>{text}</p>
      {hasProgress && 
      <ProgressStepper steps={['접수완료', '확인중', '예약완료']} currentStep={0} />}
      {subText && <p className='sub-text'>{subText}</p>}
		</div>
	);
};

export default StepComplete;